<template>
	<UnregisteredPageLayout :message="message">
		<form @submit.prevent="submitLogin">
			<input
				v-if="!message"
				type="email"
				id="email"
				v-model="email"
				required
				placeholder="Email"
			/>
			<input
				v-if="!message"
				type="password"
				id="password"
				v-model="password"
				required
				placeholder="Password"
			/>
			<button type="submit"/>
		</form>
	</UnregisteredPageLayout>
</template>

<script>
import UnregisteredPageLayout from './_PageLayout.vue'

export default {
	name: 'Login',
	components: {
		UnregisteredPageLayout
	},
	data() {
		return {
			email: '',
			password: '',
			message: ''
		}
	},
	async mounted() {
		const authToken = localStorage.getItem('authToken')?.trim()
		if (authToken && authToken !== 'null') {
			this.$router.push({ name: 'UserWireguard' })
		}
	},
	methods: {
		async submitLogin() {
			this.message = 'Logging in...'
			
			try {
				const response = await this.$api.post('/api/login', {
					email: this.email,
					password: this.password
				})
				
				localStorage.setItem('authToken', response.data.authToken)
				localStorage.setItem('userEmail', response.data.email)
				if (response.data.is_admin) {
					this.$router.push({ name: 'AdminWireguard' })
				} else {
					this.$router.push({ name: 'UserWireguard' })
				}
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.message = 'Invalid email or password'
				} else {
					this.message = 'An error occurred. Please try again.'
				}
				console.error('Error:', error)
			}
		}
	}
}
</script>

<style scoped>
</style>
